module.exports = __webpack_public_path__ + "img/discord.34773ab5.svg";